import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader.component';


export interface LoaderConfiguration {
  whitelistStrings?: string[];
}


export const CONFIG_LOADER = new InjectionToken<LoaderConfiguration>('LoaderConfiguration');

@NgModule({
  declarations: [LoaderComponent],
  imports: [
    RouterModule,
    CommonModule,
  ],
  exports: [LoaderComponent],
})
export class LoaderModule {
  static forRoot(config: LoaderConfiguration): ModuleWithProviders<LoaderModule> {
    return {
      ngModule: LoaderModule,
      providers: [
        {
          provide: CONFIG_LOADER,
          useValue: config
        }
      ]
    };
  }
}
